import { apiClient, call } from "../api/client";

/**
 * The one session query pair for the whole SPA. Stream W2's `useMe`/`useFeatureFlags` use the same keys and data
 * shape, so every screen shares one request. Screens inside the app read `useSession()` instead of fetching.
 */
export const meQueryKey = ["me"] as const;
export const featuresQueryKey = ["features"] as const;

/**
 * The test-mode switch (PUT/DELETE /auth/test-mode plus the refetch of every cached answer) runs as a mutation under
 * this key, so anything that must not act on a half-switched session (guided tours, R8-D01) can see it in flight.
 */
export const testModeSwitchKey = ["auth", "test-mode", "switch"] as const;

export function fetchMe() {
  return call(apiClient.GET("/auth/me"));
}

/**
 * The cached value under ["features"] is the flags map itself ({ Sprints: true, … }), not the response wrapper.
 * Stream W2's useFeatureFlags uses the same key and reads the map, so both must store the same shape: a wrapper
 * here made every W2 flag read as off inside the W1 shell (service desk queue shown as switched off).
 */
export async function fetchFeatures(): Promise<Record<string, boolean>> {
  return (await call(apiClient.GET("/features"))).flags;
}
